import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { requestExpenses } from '../../../actions/ExpensesActions.js';
import classNames from 'classnames';
import { Button, ButtonGroup } from 'react-bootstrap';
import UnsyncedTimeEntriesTable from './UnsyncedTimeEntriesTable.js';
import UnsyncedExpenseEntriesTable from './UnsyncedExpenseEntriesTable';

const UnsyncedItems = ({ requestExpenses }) => {
    const [currentTab, setCurrentTab] = useState('timesheets');

    return (
        <div
            className={classNames({
                entryFormCard: true,
                panelContent: true,
                unsyncedItemsPanel: true,
            })}
        >
            <ButtonGroup className="btn-expense">
                <Button
                    variant="danger"
                    value="purchase"
                    className={currentTab === 'timesheets' ? 'btn-1' : 'btn-2'}
                    onClick={() => setCurrentTab('timesheets')}
                >
                    {' '}
                    Unsynced Timesheets{' '}
                </Button>
                <Button
                    variant="primary"
                    value="bill"
                    className={currentTab === 'expenses' ? 'btn-1' : 'btn-2'}
                    onClick={() => setCurrentTab('expenses')}
                >
                    Unsynced Expenses
                </Button>
            </ButtonGroup>
            {currentTab === 'timesheets' && <UnsyncedTimeEntriesTable />}
            {currentTab === 'expenses' && <UnsyncedExpenseEntriesTable />}
        </div>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    requestExpenses,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UnsyncedItems);
